<template>
	<div
		class="modal fade"
		id="addCharge"
		tabindex="-1"
		aria-hidden="true">
		<div
			class="modal-dialog"
			:class="{ 'modal-md': type == 'Charge', 'modal-full': type != 'Charge' }"
			role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="container-fluid">
						<div class="row">
							<div class="col-9 col-sm-5 col-lg-5 my-auto">
								<h5
									class="modal-title"
									id="addChargeLabel">
									Charges
								</h5>
							</div>
							<div class="col-3 col-sm-7 my-auto">
								<div>
									<div>
										<span>
											<a class="close">
												<i
													class="far fa-times-circle fa-2x"
													data-dismiss="modal"
													id="closeAddCharge"
													aria-label="Close"></i>
											</a>
										</span>
									</div>
									<div></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<form @submit.prevent="submit">
					<div class="modal-body">
						<div class="row">
							<div class="col-xl-12">
								<!-- charge tick boxes section start -->
								<div class="container-fluid">
									<div class="row justify-content-center">
										<div class="col">
											<b-form-radio
												inline
												id="addChargeSection"
												name="typeRadio"
												value="Charge"
												v-model="type"
												>Add Charge</b-form-radio
											>
										</div>
										<div class="col">
											<b-form-radio
												inline
												id="manualInvoiceSection"
												name="typeRadio"
												value="ManualInvoice"
												v-model="type"
												@click="resetInvoiceData"
												>Manual Invoice</b-form-radio
											>
										</div>
										<div class="col">
											<b-form-radio
												inline
												id="creditNoteSection"
												name="typeRadio"
												value="CreditNote"
												v-model="type"
												@click="resetInvoiceData"
												>Credit Note</b-form-radio
											>
										</div>
									</div>
								</div>
								<hr />
								<!-- charge tick boxes section end -->

								<div
									class="container-fluid"
									v-if="type == 'Charge'">
									<div class="row">
										<div class="col-12">
											<div class="row">
												<div class="col-xl-12">
													<p class="font-weight-bold pb-2">Reason:</p>
													<!-- <form action=""> -->
													<div class="form-group mt--20">
														<b-form-select
															id="ThisIdOverwritesTheRandomlyGeneratedOneSoThatSnapshotTestsDoNotFailEveryTime_1"
															v-model="selected"
															class="form-control"
															name="selection"
															required>
															<option
																v-for="code in nominalCodes"
																:key="code.Id">
																{{ code.Description }}
															</option>
														</b-form-select>
													</div>
												</div>
											</div>
											<div class="row">
												<div class="col-xl-12">
													<div class="form-group shadow-textarea">
														<p
															for="exampleFormControlTextarea6"
															class="font-weight-bold pb-2">
															Description:
														</p>
														<textarea
															class="form-control z-depth-1 mt--20"
															id="exampleFormControlTextarea6"
															rows="2"
															maxlength="150"
															s
															v-model="notes"
															placeholder="Optional - this will be displayed on the customer's bill."></textarea>
													</div>
												</div>
											</div>
											<div class="form-group row">
												<div class="col-xl-12">
													<p class="font-weight-bold pb-2">Amount:</p>
													<div class="input-group">
														<div class="input-group-prepend">
															<span
																class="input-group-text mt--20"
																id="basic-addon1"
																>£</span
															>
														</div>
														<input
															type="number"
															step=".01"
															class="form-control mt--20"
															id="exampleFormControlTextarea6"
															v-model="amount"
															placeholder="Eg: 10.00"
															required />
													</div>
												</div>
											</div>
											<div class="row justify-content-center">
												<div class="col">
													<b-form-radio
														inline
														id="oneOffCharge"
														name="durationRadio"
														value="Adhoc"
														v-model="duration"
														>One-off</b-form-radio
													>
												</div>
												<div class="col">
													<b-form-radio
														inline
														id="perDayCharge"
														name="durationRadio"
														value="PerDay"
														v-model="duration"
														>Per Day</b-form-radio
													>
												</div>
												<div class="col">
													<b-form-radio
														inline
														id="perMonthCharge"
														name="durationRadio"
														value="PerMonth"
														v-model="duration"
														>Per Month</b-form-radio
													>
												</div>
											</div>
											<div class="row">
												<div class="col-xl-12">
													<p
														v-if="duration == 'Adhoc'"
														class="font-weight-bold mt-2 pb-2">
														Date:
													</p>
													<p
														v-else
														class="font-weight-bold pb-2">
														Start Date:
													</p>
												</div>
											</div>
											<div class="row">
												<div class="col-xl-12 mt--20">
													<el-date-picker
														v-model="pickerDate"
														format="dd.MM.yyyy"
														value-format="yyyy-MM-dd"
														type="date"
														:picker-options="startDateOptions" />
												</div>
											</div>
											<div
												class="row"
												v-if="duration != 'Adhoc'">
												<div class="col-xl-12">
													<p class="font-weight-bold pb-2">End Date:</p>
												</div>
											</div>
											<div
												class="row"
												v-if="duration != 'Adhoc'">
												<div class="col-xl-12 mt--20">
													<el-date-picker
														v-model="pickerEndDate"
														format="dd.MM.yyyy"
														value-format="yyyy-MM-dd"
														type="date"
														placeholder="Optional"
														:picker-options="endDateOptions" />
												</div>
											</div>
										</div>
									</div>
								</div>
								<div
									class="container-fluid"
									v-if="type == 'ManualInvoice' || type == 'CreditNote'">
									<div class="row">
										<div class="col-sm-6">
											<div class="row">
												<div class="col-xl-12">
													<p class="font-weight-bold pb-2">Collection Date:</p>
												</div>
												<div class="col-xl-12 mt--20">
													<el-date-picker
														v-model="collectionDate"
														:picker-options="collectionDateOptions"
														format="dd.MM.yyyy"
														value-format="yyyy-MM-dd"
														type="date" />
												</div>
											</div>
										</div>
										<div class="col-sm-6">
											<div class="row">
												<div class="col-xl-12">
													<p class="font-weight-bold pb-2">Payment Due Date:</p>
												</div>
												<div class="col-xl-12 mt--20">
													<el-date-picker
														v-model="paymentDate"
														:picker-options="collectionDateOptions"
														format="dd.MM.yyyy"
														value-format="yyyy-MM-dd"
														type="date" />
												</div>
											</div>
										</div>
									</div>

									<div
										v-if="type == 'CreditNote' && isDDAccount && collectionDate"
										class="d-flex align-items-center p-1">
										<img
											src="@/assets/img/warning_icon.png"
											style="width: 30px"
											class="d-inline"
											alt="Danger" />

										<p class="my-0 mx-1">
											Are you sure that you want to schedule a refund?
										</p>

										<label class="checkbox">
											<input
												type="checkbox"
												v-model="override" />
											<span class="default"></span>
										</label>
									</div>

									<div class="row">
										<div class="table-div col-12 mt-3 pl-3 pr-3">
											<b-table
												id="ThisIdOverwritesTheRandomlyGeneratedOneSoThatSnapshotTestsDoNotFailEveryTime_2"
												class="table-scroll tbl-sml"
												striped
												:items="invoiceItems"
												:fields="invoiceFields">
												<template
													slot="NominalCodeId"
													slot-scope="row">
													<b-form-select
														v-model="row.item.NominalCodeId"
														class="form-control borderless-input"
														@change="setDefaultTaxRate(row.item)">
														<option :value="null"></option>
														<option
															v-for="code in nominalCodes"
															:key="code.Id"
															:value="code.Id">
															{{ `${code.Description} (${code.Id})` }}
														</option>
													</b-form-select>
												</template>
												<template
													slot="Description"
													slot-scope="data">
													<textarea
														class="form-control borderless-input"
														type="text"
														maxlength="150"
														placeholder="Optional - this will be displayed on the customer's bill."
														v-model="data.item.Description" />
												</template>
												<template
													slot="Quantity"
													slot-scope="data">
													<input
														class="form-control borderless-input"
														type="number"
														min="0"
														step="1"
														required
														v-model="data.item.Quantity"
														@change="calcTotal(data.item)" />
												</template>
												<template
													slot="UnitPrice"
													slot-scope="data">
													<input
														class="form-control borderless-input"
														type="number"
														min="0"
														step=".01"
														required
														v-model="data.item.UnitPrice"
														@change="calcTotal(data.item)" />
												</template>
												<template
													slot="VatNominalCodeId"
													slot-scope="data">
													<b-form-select
														v-model="data.item.VatNominalCodeId"
														class="form-control borderless-input"
														@change="calcTotal(data.item)">
														<option :value="null"></option>
														<option value="VAT_STANDARD">Standard</option>
														<option value="VAT_REDUCED">Reduced</option>
														<option value="VAT_ZERO">Zero</option>
														<option value="VAT_EXEMPT">Exempt</option>
													</b-form-select>
												</template>
												<template
													slot="NetCharge"
													slot-scope="data">
													<input
														class="form-control borderless-input"
														type="number"
														disabled
														:value="data.item.NetCharge.toFixed(2)" />
												</template>
												<template
													slot="Actions"
													slot-scope="row">
													<div
														class="d-flex w-100 justify-content-center align-self-center">
														<i
															class="float-right pointer fas fa-trash mt-3 mx-2"
															@click="deleteItem(row)"></i>
													</div>
												</template>
											</b-table>
										</div>
									</div>

									<div class="row">
										<div class="col-sm-6">
											<a
												class="btn btn-hc"
												role="button"
												@click="addNewLine">
												<i class="fas fa-plus"></i> New Line
											</a>
										</div>
										<div class="col-sm-5">
											<div class="float-right">
												<p>Subtotal: {{ net | currency }}</p>
												<div v-if="vatTotals.length > 0">
													<p
														v-for="(total, index) in vatTotals"
														:key="index">
														Total VAT {{ total.VatRate }}%:
														{{ total.VatTotal | currency }}
													</p>
												</div>
												<hr />
												<h4>Total: {{ gross | currency }}</h4>
												<hr />
											</div>
										</div>
										<div class="col-sm-1"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- modal body closed -->
					<div class="modal-footer">
						<button
							class="btn btn-hc float-right"
							:disabled="
								submitStatus === 'PENDING' ||
								(((type == 'ManualInvoice' && isDDAccount && !collectionDate) ||
									(type != 'Charge' && !isDDAccount && collectionDate) ||
									(type == 'CreditNote' && isDDAccount && collectionDate)) &&
									!override) ||
								((this.type == 'ManualInvoice' || this.type == 'CreditNote') &&
									this.invoiceItems.length == 0)
							">
							Add
							{{ type | splitString }}
						</button>
						<!-- this to only appear when everything is valid -->
					</div>
				</form>
			</div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import Swal from 'sweetalert2';
import _filters from '@/mixins/filters.js';

export default {
	mixins: [_filters],
	data() {
		return {
			pickerDate: moment().format('YYYY-MM-DD'),
			collectionDateOptions: {
				disabledDate: (date) => {
					return (
						moment(date).day() == 6 ||
						moment(date).day() == 0 ||
						moment(this.thirdBacsDateFromNow).isAfter(date)
					);
				},
			},
			startDateOptions: {
				disabledDate: (date) => {
					if (this.duration != 'Adhoc') {
						return date > moment(this.pickerEndDate);
					}
				},
			},

			pickerEndDate: null,
			endDateOptions: {
				disabledDate: (date) => {
					return date < moment(this.pickerDate);
				},
			},
			notificationClasses: null,
			selected: null,
			amount: null,
			submitStatus: null,
			type: 'Charge',
			duration: 'Adhoc',
			notes: null,
			invoiceFields: {
				NominalCodeId: {
					label: 'Item',
					class: 'col-3',
				},
				Description: {
					label: 'Description',
					class: 'col-3',
				},
				Quantity: {
					label: 'Quantity',
				},
				UnitPrice: {
					label: 'Unit Price',
				},
				VatNominalCodeId: {
					label: 'Tax Rate',
					class: 'col-2',
				},
				NetCharge: {
					label: 'Amount',
				},
				Actions: {
					label: '',
				},
			},
			thirdBacsDateFromNow: null,
			collectionDateVal: null,
			paymentDateVal: null,
			override: false,
		};
	},
	validations: {
		selected: {
			required,
		},
		amount: {
			required,
		},
		date: {
			required,
		},
		duration: {
			required,
		},
	},
	async mounted() {
		this.$root.$on('bv::show::modal', (bvEvent) => {
			if (bvEvent === 'addCharge') {
				this.pickerEndDate = null;
				this.collectionDateVal = null;
				this.paymentDateVal = null;
				this.override = false;
				this.notificationClasses = null;
				this.selected = null;
				this.amount = null;
				this.submitStatus = null;
				this.type = 'Charge';
				this.duration = 'Adhoc';
				this.notes = null;
			}
		});

		this.getThirdBacsDate();
		let { NextBacsDay, BacsDay } = await this.checkBacsDate(
			this.collectionDate
		);
		if (!BacsDay) this.collectionDate = NextBacsDay;
	},
	methods: {
		addNewLine() {
			this.invoiceItems.push({
				Description: null,
				NetCharge: 0,
				NominalCodeId: null,
				Quantity: 1,
				RootNominalCodeId: null,
				UnitPrice: parseFloat(0).toFixed(2),
				VatNominalCodeId: null,
				VatRate: null,
			});
		},
		deleteItem(row) {
			this.invoiceItems.splice(row.index, 1);
			this.calcVatTotals();
		},
		setDefaultTaxRate(item) {
			if (item.NominalCodeId) {
				var nominal = this.$_.findWhere(this.nominalCodes, {
					Id: item.NominalCodeId,
				});
				item.VatNominalCodeId = nominal.VatCodeId;
				item.Description = nominal.Description;
				item.UnitPrice = nominal.hasOwnProperty('DefaultAmount')
					? nominal.DefaultAmount.toFixed(2)
					: parseFloat(0).toFixed(2);
				item.VatRate =
					item.VatNominalCodeId != 'VAT_EXEMPT'
						? this.$_.sortBy(
								this.$_.where(this.taxRates, {
									NominalCodeId: item.VatNominalCodeId,
								}),
								'EffectiveFrom'
            ).reverse()[0].Rate
						: null;
				item.RootNominalCodeId = item.NominalCodeId;
			}
			this.calcTotal(item);
		},
		calcTotal(item) {
			item.Quantity = Math.abs(parseInt(item.Quantity));
			item.UnitPrice = Math.abs(parseFloat(item.UnitPrice)).toFixed(2);
			item.NetCharge = Math.abs(
				Number(Math.round(item.Quantity * item.UnitPrice + 'e2') + 'e-2')
			);
			item.VatRate =
				item.VatNominalCodeId != 'VAT_EXEMPT'
					? this.$_.sortBy(
							this.$_.where(this.taxRates, {
								NominalCodeId: item.VatNominalCodeId,
							}),
							'EffectiveFrom'
          ).reverse()[0].Rate
					: null;
			this.calcVatTotals();
		},
		resetInvoiceData() {
			this.invoiceItems = [];
			this.invoiceGross = 0;
			this.invoiceNet = 0;
			this.vatTotals = [];
			this.collectionDate = null;
			this.override = false;
			this.calcVatTotals();
		},
		// wordSplit(word) {
		//     var foo = '';
		//     var splitWord = word.split(/(?=[A-Z0-9])/);
		//     for (let i = 0; i < splitWord.length; i++) {
		//         foo += splitWord[i] + ' ';
		//     }
		//     return foo;
		// },
		submit() {
			if (this.type == 'Charge') {
				this.addCharge();
			}
			if (this.type == 'ManualInvoice' || this.type == 'CreditNote') {
				this.addInvoice();
			}
		},
		addCharge() {
			if (this.pickerDate == '' || this.pickerDate == null) {
				this.$snotify.warning(`Please provide a date for the charge.`);
				return false;
			}
			if (
				this.duration != 'Adhoc' &&
				(this.pickerDate == '' || this.pickerDate == null)
			) {
				this.$snotify.warning(`Please provide a start date for the charge.`);
				return false;
			}
			if (this.duration == '' || this.duration == null) {
				this.$snotify.warning(`Please select a charge duration.`);
				return false;
			}
			this.submitStatus = 'PENDING';
			document.getElementById('closeAddCharge').click();
			setTimeout(() => {
				this.$http
					.post(
						'https://' +
							this.$config.honeycomb.billbot.domain +
							'/api/v1/charges',
						{
							Amount: this.amount,
							ChargeStartDate: moment.utc(this.pickerDate).format(),
							ChargeEndDate:
								this.duration != 'Adhoc'
									? this.pickerEndDate != null
										? moment.utc(this.pickerEndDate).format()
										: undefined
									: undefined,
							CustomerId: this.$store.state.customers.customer.Id,
							Duration: this.duration,
							Reason: this.selected,
							NominalCode: this.$_.findWhere(this.nominalCodes, {
								Description: this.selected,
							}).Id,
							VatNominalCode: this.$_.findWhere(this.nominalCodes, {
								Description: this.selected,
							}).VatCodeId,
							Notes: this.notes,
						},
						{
							withCredentials: true,
						}
					)
					.then(() => {
						(this.selected = null),
							(this.amount = null),
							(this.duration = 'Adhoc'),
							(this.pickerDate = moment().format('YYYY-MM-DD'));
						(this.pickerEndDate = null), (this.notes = null);
						this.submitStatus = 'OK';
						this.$snotify.success(`Success! Charge added.`);
						this.$store.dispatch('getCharges');
						document.getElementById('closeAddCharge').click();
					})
					.catch((error) => {
						// Error
						if (error.response) {
							// The request was made and the server responded with a status code
							// that falls out of the range othisf 2xx
							this.submitStatus = 'Error';
							if (error.response.data.MoreInformation.length > 0) {
								error.response.data.MoreInformation.forEach((e) => {
									this.$snotify.error(`${e.Error}`, {
										timeout: 0,
										closeOnClick: true,
									});
								});
							} else {
								this.$snotify.error(`${error.response.data.UserDescription}`, {
									timeout: 0,
									closeOnClick: true,
								});
							}
						} else if (error.request) {
							// The request was made but no response was received
							// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
							// http.ClientRequest in node.js
							this.submitStatus = 'Error';
							this.$snotify.error(`No response received.`, {
								timeout: 0,
								closeOnClick: true,
							});
						} else {
							// Something happened in setting up the request that triggered an Error
							this.submitStatus = 'Error';
							this.$snotify.error(`${error.message}`, {
								timeout: 0,
								closeOnClick: true,
							});
						}
					});
			});
		},
		addInvoice() {
			this.submitStatus = 'PENDING';
			this.$http
				.post(
					'https://' +
						this.$config.honeycomb.moneybot.domain +
						'/api/v1/SalesTransactions',
					{
						AccountId: this.customer.AccountId,
						Collected: false,
						CreatedBy: this.userEmail,
						CustomerName: `${this.customer.CustomerName}`,
						CustomerAddress:
							this.customer.BillingContact.Address.AddressLines.join('\n'),
						Description:
							this.type == 'ManualInvoice'
								? 'Manual Invoice'
								: 'Manual Credit Note',
						Gross: Number(Math.round(this.gross + 'e2') + 'e-2'),
						Items: this.invoiceItems,
						Net: this.net,
						CollectionDue: this.collectionDate,
						PaymentDue: this.paymentDate,
						TaxPoint: moment.utc(moment().format('YYYY-MM-DD')).format(),
						TransactionType: this.type == 'ManualInvoice' ? 'Debit' : 'Credit',
						Type: this.type == 'ManualInvoice' ? 'Invoice' : 'CreditNote',
						VatTotals: this.vatTotals.length > 0 ? this.vatTotals : undefined,
					},
					{
						withCredentials: true,
					}
				)
				.then(() => {
					this.submitStatus = 'OK';
					this.$snotify.success(`Success! ${this.wordSplit(this.type)} added.`);
					this.resetInvoiceData();
					this.$store.dispatch('getLedger');
					this.$store.dispatch('getSalesTransactions');
					document.getElementById('closeAddCharge').click();
				})
				.catch((error) => {
					// Error
					if (error.response) {
						// The request was made and the server responded with a status code
						// that falls out of the range othisf 2xx
						this.submitStatus = 'ERROR';
						Swal({
							toast: true,
							position: 'top-end',
							type: 'error',
							title: error.response.data.UserDescription,
							showConfirmButton: false,
							timer: 2500,
						});
					} else if (error.request) {
						// The request was made but no response was received
						// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
						// http.ClientRequest in node.js
						this.submitStatus = 'ERROR';
						Swal({
							toast: true,
							position: 'top-end',
							type: 'error',
							title: 'No response received',
							showConfirmButton: false,
							timer: 2500,
						});
					} else {
						// Something happened in setting up the request that triggered an Error
						this.submitStatus = 'ERROR';
						Swal({
							toast: true,
							position: 'top-end',
							type: 'error',
							title: error.message,
							showConfirmButton: false,
							timer: 2500,
						});
					}
				});
		},
		calcVatTotals() {
			var vatTotals = [];
			var gross = 0;
			var net = 0;
			var rates = [
				{
					VatNominalCodeId: 'VAT_STANDARD',
					VatRootNominalCodeId: 'VAT_STANDARD',
					NetTotal: 0,
					VatRate: this.$_.sortBy(
						this.$_.where(this.taxRates, { NominalCodeId: 'VAT_STANDARD' }),
						'EffectiveFrom'
					).reverse()[0].Rate,
					VatTotal: 0,
				},
				{
					VatNominalCodeId: 'VAT_REDUCED',
					VatRootNominalCodeId: 'VAT_REDUCED',
					NetTotal: 0,
					VatRate: this.$_.sortBy(
						this.$_.where(this.taxRates, { NominalCodeId: 'VAT_REDUCED' }),
						'EffectiveFrom'
					).reverse()[0].Rate,
					VatTotal: 0,
				},
				{
					VatNominalCodeId: 'VAT_ZERO',
					VatRootNominalCodeId: 'VAT_ZERO',
					NetTotal: 0,
					VatRate: this.$_.sortBy(
						this.$_.where(this.taxRates, { NominalCodeId: 'VAT_ZERO' }),
						'EffectiveFrom'
					).reverse()[0].Rate,
					VatTotal: 0,
				},
				{
					VatNominalCodeId: 'VAT_EXEMPT',
					VatRootNominalCodeId: 'VAT_EXEMPT',
					NetTotal: 0,
					VatRate: 0,
					VatTotal: 0,
				},
			];
			rates.forEach((rate) => {
				var total = 0;
				this.invoiceItems.forEach((item) => {
					if (item.VatNominalCodeId == rate.VatNominalCodeId) {
						total += item.NetCharge;
					}
				});
				rate.NetTotal = total;
				rate.VatTotal = Number(
					Math.round((total * rate.VatRate) / 100 + 'e2') + 'e-2'
				);
				if (rate.NetTotal > 0 && rate.VatNominalCodeId != 'VAT_EXEMPT') {
					vatTotals.push(rate);
				}
				net += rate.NetTotal;
				gross += rate.NetTotal + rate.VatTotal;
			});
			this.vatTotals = vatTotals;
			this.gross = gross;
			this.net = net;
		},
		async getThirdBacsDate() {
			let date = moment().format('YYYY-MM-DD');
			let res = await this.checkBacsDate(date);

			if (!res.BacsDay) res = await this.checkBacsDate(res.NextBacsDay);

			res = await this.checkBacsDate(res.NextBacsDay);
			res = await this.checkBacsDate(res.NextBacsDay);

			this.thirdBacsDateFromNow = res.NextBacsDay;
		},
		async checkBacsDate(date) {
			try {
				const path = `https://${Vue.config.honeycomb.ddbot.domain}/api/v1/bacs-calendar/${date}`;
				let { data } = await this.$http.get(path);
				return data;
			} catch (error) {
				this.$snotify.error(
					`${
						error.response.data.UserDescription ||
						'Failed to vaildate BACS date'
					}`,
					{ timeout: 0, closeOnClick: true }
				);
			}
		},
	},
	computed: {
		selection() {
			return this.$_.where(this.nominalCodes, {
				Description: this.selected,
			});
		},
    nominalCodes() {
      return this.$_.sortBy(
       this.$store.state.finances.nominals.filter(n => n.IsVisible !== false), 'Description'
      );
    },
		taxRates() {
			return this.$store.state.finances.taxes;
		},
		customer() {
			return this.$store.state.customers.customer;
		},
		isDDAccount() {
			return this.$store.state.customers.account.CollectionMethod.startsWith(
				'DD'
			);
		},
		userEmail() {
			return this.$auth.decodedToken.payload.sub;
		},
		invoiceItems: {
			get() {
				return this.$store.state.finances.invoiceItems;
			},
			set(items) {
				this.$store.commit('updateInvoiceItems', items);
			},
		},
		vatTotals: {
			get() {
				return this.$store.state.finances.vatTotals;
			},
			set(totals) {
				this.$store.commit('updateVatTotals', totals);
			},
		},
		gross: {
			get() {
				return this.$store.state.finances.invoiceGross;
			},
			set(gross) {
				this.$store.commit('updateInvoiceGross', gross);
			},
		},
		net: {
			get() {
				return this.$store.state.finances.invoiceNet;
			},
			set(net) {
				this.$store.commit('updateInvoiceNet', net);
			},
		},

		collectionDueDays() {
			if (!this.$store.state.customers.account) return;

			return (
				this.$store.state.customers.account.CollectionDueDays ||
				Vue.config.honeycomb.moneybot.defaultCollectionDueDays
			);
		},

		collectionDate: {
			get() {
				if (['CreditNote', 'ManualInvoice'].includes(this.type))
					return this.collectionDateVal;

				return (
					this.collectionDateVal ||
					moment().add(this.collectionDueDays, 'days').format('YYYY-MM-DD')
				);
			},
			set(val) {
				this.collectionDateVal = val;
				if (val != null)
					this.checkBacsDate(val).then(({ NextBacsDay, BacsDay }) => {
						if (!BacsDay) {
							this.collectionDateVal = NextBacsDay;
							this.$snotify.warning(
								`Date selected is not a vaild BACS date. Selected date has been changed to next BACS day`,
								{ timeout: 5000 }
							);
						}
					});
			},
		},

		paymentDueDays() {
			if (!this.$store.state.customers.account) return;

			return (
				this.$store.state.customers.account.PaymentDueDays ||
				Vue.config.honeycomb.moneybot.defaultPaymentDueDays
			);
		},

		paymentDate: {
			get() {
				return (
					this.paymentDateVal ||
					moment().add(this.paymentDueDays, 'days').format('YYYY-MM-DD')
				);
			},
			set(val) {
				this.paymentDateVal = val;
				if (val != null)
					this.checkBacsDate(val).then(({ NextBacsDay, BacsDay }) => {
						if (!BacsDay) {
							this.paymentDateVal = NextBacsDay;
							this.$snotify.warning(
								`Date selected is not a vaild BACS date. Selected date has been changed to next BACS day`,
								{ timeout: 5000 }
							);
						}
					});
			},
		},
	},
};
</script>
